import { getIsActivityV3RecentsEnabled } from '@confluence/activity-v3-enabled/entry-points/getIsActivityV3RecentsEnabled.ts';
import { useIsWhiteboardFeatureEnabled } from '@confluence/whiteboard-utils/entry-points/useIsWhiteboardFeatureEnabled.ts';
import { isContentTypeEnabledInCurrentEnv } from '@confluence/content-types-utils/entry-points/isContentTypeEnabledInCurrentEnv.ts';

import type { RecentListHomeRecentWorkV3Query as RecentListHomeRecentWorkV3Query$data } from './__types__/RecentListHomeRecentWorkV3Query.ts';
import type { RecentListHomeRecentWorkQuery as RecentListHomeRecentWorkQuery$data } from './__types__/RecentListHomeRecentWorkQuery.ts';
import { ALL_RECENT_ITEMS_COUNT_HOME_REFRESH } from './recentListConstants.ts';
import { useHomeRecentWorkData } from './useHomeRecentWorkData.ts';
import { filteredRecents, filteredRecentsV3 } from './RecentList.tsx';
import { expValEquals } from '@confluence/feature-experiments';
import { useIsNewUser } from '@confluence/targeting/entry-points/useIsNewUser.ts';

export const useIsEligibleForHideRecents = () => {
	const { isNewUser } = useIsNewUser(
		{ activeDaysThreshold: 28 },
		!expValEquals('cc-hide-pickup-where-you-left-off-exp', 'cohort', 'experiment'),
	);
	const { isWhiteboardFeatureEnabled } = useIsWhiteboardFeatureEnabled();
	const isWhiteboardViewedEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
	const isDatabaseEnabled = isContentTypeEnabledInCurrentEnv('database');
	const isActivityV3Enabled = getIsActivityV3RecentsEnabled();
	const { data, loading } = useHomeRecentWorkData({
		isWhiteboardViewedEnabled,
		isDatabaseEnabled,
		first: ALL_RECENT_ITEMS_COUNT_HOME_REFRESH,
	});

	const recents = isActivityV3Enabled
		? filteredRecentsV3(
				data as RecentListHomeRecentWorkV3Query$data,
				false,
				ALL_RECENT_ITEMS_COUNT_HOME_REFRESH,
			)
		: filteredRecents(
				data as RecentListHomeRecentWorkQuery$data,
				false,
				ALL_RECENT_ITEMS_COUNT_HOME_REFRESH,
			);
	return (
		!loading &&
		!recents.length &&
		isNewUser &&
		expValEquals('cc-hide-pickup-where-you-left-off-exp', 'cohort', 'experiment')
	);
};
